import { Users, CalendarDays, ScanLine, KanbanSquare } from 'lucide-react';
import { WidgetContainer } from '../../infrastructure/widgets/WidgetContainer';
import { StatCard } from '../../infrastructure/widgets/StatCard';
import { useEmployeeOverview } from './hooks/useEmployeeOverview';
import { WidgetConfig } from '../../infrastructure/contracts/widget.contract';

export const employeeOverviewConfig: WidgetConfig = {
  id: 'dash-employee-overview',
  title: 'Overview',
  category: 'statistics',
  description: 'Your key performance indicators',
  refreshStrategy: 'manual',
  defaultSize: { w: 4, h: 2 },
  priority: 1,
};

export function EmployeeOverviewWidget() {
  const { data, isLoading, isError, error, refetch } = useEmployeeOverview();

  return (
    <WidgetContainer
      config={employeeOverviewConfig}
      isLoading={isLoading}
      isError={isError}
      errorMessage={error?.message}
      onRefresh={() => { refetch(); }}
    >
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard
          data={{ label: "Total Leads", value: data?.totalLeads ?? 0, status: 'info' }}
          icon={<Users className="h-4 w-4" />}
        />
        <StatCard
          data={{ label: "Leads Today", value: data?.leadsToday ?? 0, status: 'success' }}
          icon={<CalendarDays className="h-4 w-4" />}
        />
        <StatCard
          data={{ label: "Scans Today", value: data?.scansToday ?? 0, status: 'warning' }}
          icon={<ScanLine className="h-4 w-4" />}
        />
        <StatCard
          data={{ label: "Pipeline", value: data?.pipeline ? Object.values(data.pipeline).reduce((a, b) => a + b, 0) : 0, status: 'info' }}
          icon={<KanbanSquare className="h-4 w-4" />}
        />
      </div>
    </WidgetContainer>
  );
}
